import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import CurrencyFormat from 'react-currency-format';
import {
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  makeStyles
} from '@material-ui/core';
import { MoreVert as MoreVertIcon } from '@material-ui/icons';
import PerfectScrollbar from 'react-perfect-scrollbar';
// utils

const useStyles = makeStyles((theme) => ({
  root: {},
  moreVert: {
    cursor: 'pointer'
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  dateAfter: {
    color: '#bbb'
  },
  true: {
    fill: theme?.palette?.primary?.main,
  },
  false: {
    fill: '#aaa'
  },
  statusCell: {
    position: 'relative'
  },
  statusPanel: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: 120,
    backgroundColor: 'white',
    borderRadius: '.2rem',
    border: '1px solid #ddd',
  },
  statusPanelList: {
    listStyle: 'none'
  },
  statusPanelItem: {
    padding: 0,
    margin: 0,
    '& > a': {
      display: 'block',
      padding: '.75rem 1rem',
      cursor: 'pointer',
      fontFamily: 'sans-serif',
      fontSize: '.9rem',
      '&:hover': {
        backgroundColor: '#eee'
      }
    }
  }
}));

const Results = ({
  className, data, onRefresh, ...rest
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [panel, setPanel] = useState(null);
  const [panelPosition, setPanelPosition] = useState({ x: 0, y: 0 });
  const [coupons, setCoupons] = useState([]);

  const translateType = (type) => {
    switch (type) {
      case 'amount':
        return 'Monto';
      case 'percentage':
        return 'Porcentaje';
      case 'delivery':
        return 'Domicilio gratis';
      default: return '';
    }
  };

  const formatDate = (date) => {
    return date.substring(0, 10).substring(8, 10)
      + date.substring(0, 10).substring(4, 8)
      + date.substring(0, 10).substring(0, 4);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const toggleMenu = (e) => setCoupons(!coupons ? e.currentTarget : null);

  const redirect = () => {
    navigate(`/app/cupones/${panel}/editar`, { replace: true });
    toggleMenu();
  };

  const onClick = (e, coupon) => {
    setPanel(panel ? null : coupon?.id);
    setPanelPosition(panel ? { x: 0, y: 0 } : { x: e.clientX, y: e.clientY });
  };

  const closePanel = () => {
    setTimeout(() => {
      setPanel(null);
      setPanelPosition({ x: 0, y: 0 });
    }, 50);
  };

  useEffect(() => {
    if (panel) {
      document.addEventListener('click', closePanel);
    }

    return () => {
      document.removeEventListener('click', closePanel);
    };
  }, [panel]);

  useEffect(() => {
    if (Array.isArray(data)) {
      setCoupons(data);
    }
  }, [data]);

  return (
    <>
      <Card
        className={clsx(classes.root, className)}
        {...rest}
      >
        <PerfectScrollbar>
          <Box minWidth={1500}>
            <Table>
              <TableHead style={{ borderBottom: '1px solid rgb(224, 224, 224)' }}>
                <TableRow>
                  <TableCell>
                    Titulo
                  </TableCell>
                  {/* <TableCell>
                    Descripción
                  </TableCell> */}
                  <TableCell>
                    Código
                  </TableCell>
                  <TableCell>
                    Tipo
                  </TableCell>
                  <TableCell>
                    Valor
                  </TableCell>
                  <TableCell>
                    Inicio
                    <br />
                    (DD-MM-AAAA)
                  </TableCell>
                  <TableCell>
                    Expiración
                    <br />
                    (DD-MM-AAAA)
                  </TableCell>
                  <TableCell>
                    Lím. usos
                  </TableCell>
                  <TableCell>
                    Cliente
                  </TableCell>
                  <TableCell>
                    Marca
                  </TableCell>
                  <TableCell>
                    Sucursal
                  </TableCell>
                  <TableCell>
                    Terminos y condiciones
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {coupons.slice(page * limit, (limit * (page + 1))).map((coupon) => (
                  <TableRow
                    hover
                    key={coupon?.id}
                  >
                    <TableCell>
                      <Typography
                        color="textPrimary"
                        variant="body2"
                      >
                        {coupon?.title}
                      </Typography>
                    </TableCell>
                    {/* <TableCell>
                      <Typography
                        color="textPrimary"
                        variant="body2"
                      >
                        {coupon?.description}
                      </Typography>
                    </TableCell> */}
                    <TableCell>
                      <Typography
                        color="textPrimary"
                        variant="body2"
                      >
                        {coupon?.key}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        color="textPrimary"
                        variant="body2"
                      >
                        {translateType(coupon?.type)}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      {
                        coupon?.type === 'delivery' ? (
                          <Typography
                            color="textPrimary"
                            variant="body2"
                          >
                            No aplica
                          </Typography>
                        ) : (
                          <Typography
                            color="textPrimary"
                            variant="body2"
                          >
                            $
                            <CurrencyFormat value={coupon?.value} displayType="text" thousandSeparator="." decimalSeparator="," />
                          </Typography>
                        )
                      }
                    </TableCell>
                    <TableCell>
                      <Typography
                        color="textPrimary"
                        variant="body2"
                      >
                        {formatDate(coupon?.started_at)}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        color="textPrimary"
                        variant="body2"
                      >
                        {formatDate(coupon?.expired_at)}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        color="textPrimary"
                        variant="body2"
                      >
                        {coupon?.max}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        color="textPrimary"
                        variant="body2"
                      >
                        {coupon?.client ? `${coupon?.client?.first_name} ${coupon?.client?.last_name}` : 'No aplica'}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        color="textPrimary"
                        variant="body2"
                      >
                        {coupon?.brand?.name || 'No aplica'}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        color="textPrimary"
                        variant="body2"
                      >
                        {coupon?.branch_office?.name || 'No aplica'}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        color="textPrimary"
                        variant="body2"
                      >
                        {coupon?.term_and_conditions?.title || 'No aplica'}
                      </Typography>
                    </TableCell>
                    <TableCell className={classes?.statusCell}>
                      <MoreVertIcon
                        className={classes?.moreVert}
                        onClick={(e) => onClick(e, coupon)}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        </PerfectScrollbar>
        <TablePagination
          component="div"
          count={coupons.length}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleLimitChange}
          page={page}
          rowsPerPage={limit}
          rowsPerPageOptions={[5, 10, 20, 50, 100]}
          labelRowsPerPage="Filas por página"
        />
      </Card>
      {
        panel !== null && (
          <div
            className={classes?.statusPanel}
            style={{
              top: panelPosition?.y,
              left: panelPosition?.x - 120
            }}
          >
            <ul className={classes?.statusPanelList}>
              <li className={classes?.statusPanelItem}>
                <a onClick={() => redirect('edit')}>
                  Editar
                </a>
              </li>
            </ul>
          </div>
        )
      }
    </>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  onRefresh: PropTypes.func,
  data: PropTypes.array.isRequired
};

Results.defaultProps = {
  className: '',
  onRefresh: () => null,
};

export default Results;
